import React, { useState } from 'react';
import { toast } from 'react-toastify';
import EquipmentForm, {
  EquipmentFormFields,
} from '../../components/Equipment/EquipmentForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

interface EquipmentsNewProps {
  customerId: number;
  setIsOpenModal: (isOpen: boolean) => void;
}

export default function EquipmentsNew({
  customerId,
  setIsOpenModal,
}: EquipmentsNewProps) {
  const {
    user: { organization },
  } = useAuth();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: EquipmentFormFields) => {
    try {
      await api.post(
        `organizations/${organization.id}/customers/${customerId}/equipments`,
        data
      );
      toast.success('Equipamento adicionado com sucesso');
      setIsOpenModal(false);
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const [formFields, setFormFields] = useState<EquipmentFormFields>(
    {} as EquipmentFormFields
  );

  return (
    <EquipmentForm
      isLoading={1 + 1 === 1}
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
